import { createdCoreTable } from '../components/core-table'
import { coreTableProps } from '../props'
import { RIGHT_TABLE } from '../config'

const CoreTable = createdCoreTable()
export function createRightTable() {
  return {
    name: 'RightTable',
    props: coreTableProps,
    render() {
      const coreTableAttribute = {
        props: {
          ...this.$props,
          type: RIGHT_TABLE
        },
      }
      return (
        this.$props.columns.length ? <CoreTable {...coreTableAttribute} ref="rightTable">
            {this.$slots.default}
          </CoreTable>
        : null
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/layout/right-table.js